import React from 'react'
import intershipduration from "../../assets/images/intershipduration.svg";
import intershiptype from "../../assets/images/intershiptype.svg";
import booktimeslot from "../../assets/images/booktimeslot.svg";
import bookseat from "../../assets/images/book-seat.svg";
import finishyourprogress from "../../assets/images/finish-your-progress.svg";
import personalinfo from "../../assets/images/personal-info-icon.png";
import Sidebar from '../Internships/components/internshipweb';
import SidebarTabs from '../Internships/components/internshipweb';
import InternshipSection from '../Internships/components/internshipweb';
const WebDevelopment = () => {
  return (
    <>
      <div className='container my-5 enroll'>
        <div className='row py-5  '>

        <div className=" col-md-6 ">
          <div className='mt-5 px-5 me-3'> 
                <div className="">
                  <h3 className=" course-heading  " >MERN Development</h3>
                  <p className="text-justify">By following these five steps, you will gain comprehensive knowledge and insights, ensuring a structured and efficient development process. This will enhance your skills, enabling you to deliver high-quality app and web development projects with confidence and expertise, while continuously improving your technical capabilities.</p>
                
            </div>  </div>
          </div> 
          <div className=' col-md-6  ' >
          <div className='mt-2'> 
            <img  className="img-fluid mx-auto d-flex" width="100%" src={require('../../assets/images/Hire-our-Wordpress-Developer.png')} /> </div>
        </div></div>
        </div>
       <InternshipSection/>
      
    </>
  )
}

export default WebDevelopment